import '@nackle/game-loader/build/loader.js';
import gameLoaderHtml from '@nackle/game-loader/build/index.html';
import IMG_AWARD_SWIRL from '@nackle/game-loader-component/static/award-swirl.png';

export { gameLoaderHtml, IMG_AWARD_SWIRL };
